import { AGENT_TRACKER_DATA } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { getCallTimeFromTimestamp } from "../../../base/utils";
import moment from "moment";

export const initialState = {
  agentTrackerData: [] as any,
  liveSessions: [] as any,
  agentList: [] as any,
  interval: "",
};

const agentTrackerSlice = createSlice({
  name: AGENT_TRACKER_DATA,
  initialState,
  reducers: {
    updateAgentTrackerData: (state, { payload }) => {
      state.agentTrackerData = payload.agentTrackerData;
    },
    liveSessions: (state, { payload }) => {
      state.liveSessions = payload;
    },
    updateAgentList: (state, { payload }) => {
      state.agentList = payload.agentList;
    },
    updateUserInAgentTracker: (state, { payload }) => {
      const index = state.agentTrackerData?.findIndex((user: any) => user?.emailId?.toString()?.toLowerCase() === payload?.email?.toString()?.toLowerCase());
      if (index !== -1) {
        const status = state?.agentTrackerData[index]?.statusName;
        if (status !== payload?.status) {
          state.agentTrackerData[index] = { ...state.agentTrackerData[index], statusName: payload.status, stateTimer: Date.now() / 1000 };
        }
      }
    },

    agentTimer: (state) => {
      state.agentTrackerData.map((data: any) => {
        return (data.Timer = getCallTimeFromTimestamp(data?.stateTimer));
      });
    },

    reset: () => {},
  },
});
export const agentTrackerActions = agentTrackerSlice.actions;
export default agentTrackerSlice.reducer;
